import React from 'react';
import {Typography} from "@mui/material";
import {AiMentionsFinalCtaContent} from "../../models/AiMentionsContent";

interface FinalCtaProps {
    content: AiMentionsFinalCtaContent;
    // The SAME WhatsApp action as the hero's primary CTA - one entry point, one
    // prefilled message.
    onCta: () => void;
    onSecondaryLink: () => void;
}

const FinalCta: React.FC<FinalCtaProps> = ({content, onCta, onSecondaryLink}) => (
    <section className="lnk-aim__final">
        <Typography variant="h4" component="h2">{content.title}</Typography>
        <p>{content.subtitle}</p>

        <button type="button" className="lnk-aim__final-cta" onClick={onCta}>
            {content.buttonLabel}
        </button>

        <div className="lnk-aim__final-sub">
            <a href="#/ai-mentions" onClick={event => {
                event.preventDefault();
                onSecondaryLink();
            }}>
                {content.linkText}
            </a>
        </div>
    </section>
);

export default FinalCta;
